var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as go from '../../../../libs/gojs/release/go';
import { LineElement } from './base/line-element';
import { DiagramConsts } from '../diagram-consts';
import { ConditionItemModel } from '../../element-setting/shared/condition/condition-item-model';
import { ConditionType } from '../../element-setting/shared/condition/condition-type';
import { RelationType } from '../../element-setting/shared/condition/comm/relation-type';
import { BitConditionModel } from '../../element-setting/shared/condition/bit/bit-condition-model';
import { BitConditonLogic } from '../../element-setting/shared/condition/bit/bit-condition-logic';
import { FlowDirectionType } from '../utils/pipe/flow-direction-type';
var PipeElement = /** @class */ (function (_super) {
    __extends(PipeElement, _super);
    function PipeElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PipeElement.prototype.compile = function (model, data, svg) {
        model['version'] = 4;
        model['isPipeWall'] = data.isPipeWall;
        model['isFlowBlock'] = data.isFlowBlock;
        model['isFlow'] = data.isFlow ? data.isFlow : false;
        model['pipeDiameter'] = null != data.pipeDiameter ? data.pipeDiameter : 14;
        model['pipeWallSize'] = null != data.pipeWallSize ? data.pipeWallSize : 1;
        model['pipeWallColor'] = data.pipeWallColor ? data.pipeWallColor : '#333';
        model['blockColor'] = data.blockColor ? data.blockColor : '#0081ff';
        model['blockWidth'] = null != data.blockWidth ? data.blockWidth : 6;
        model['blockLength'] = null != data.blockLength ? data.blockLength : 12;
        model['blockMargin'] = null != data.blockMargin ? data.blockMargin : 6;
        model['backGroundColor'] = data.backGroundColor ? data.backGroundColor : '#ffffff';
        model['flowDirection'] = data.flowDirection ? data.flowDirection : FlowDirectionType.Positive;
        // 显示设置
        model['isAwaysDisplay'] = data.isAwaysDisplay;
        model['isDisplayControl'] = data.displayLogicEnabled;
        model['conditionItems'] = data.conditionItems;
        if (data.permissionsForDisplaySetting) {
            model['isDisplayPermission'] = data.permissionsForDisplaySetting.PermissionEnabled;
            model['displayPermissionCodes'] = data.permissionsForDisplaySetting.PermissionList;
        }
        // 启停控制
        model['isControl'] = data.isFlow;
        if (data.controlItems == null) {
            this.setControlItems(model, data);
        }
        model['controlItems'] = data.controlItems;
        // 默认的直管会生成多余的path，这里移除掉。
        svg.find("path[fill='black']").remove();
        // 移除生成的管道流动路径。
        svg.children().eq(2).removeAttr('d');
    };
    PipeElement.prototype.setControlItems = function (model, data) {
        if (data.isFlow && data.variableName) {
            var variable = _.find(DiagramConsts.compilerUsedVariables, function (v) { return v.variableName === data.variableName; });
            if (null != variable) {
                var bitCondition = new ConditionItemModel(0, ConditionType.Bit, new BitConditionModel(variable.variableName, undefined, BitConditonLogic.On, data.dataSourceCode, false, 0, data.variableVersion), RelationType.None);
                data.controlItems = [bitCondition];
            }
        }
    };
    PipeElement.prototype.getPaletteTemplate = function () {
        var $ = go.GraphObject.make;
        return $(go.Node, 'Vertical', { width: 50, height: 90, locationSpot: go.Spot.Center }, $(go.Picture, { margin: 10, source: '/assets/common/images/configure/elements/pipe.png' }), $(go.TextBlock, {
            alignment: go.Spot.Center,
            text: this.l(this.getCategoryKey()),
            editable: false
        }));
    };
    PipeElement.prototype.getDiagramTemplate = function () {
        var _this = this;
        var $ = go.GraphObject.make;
        return $(go.Node, 'Spot', {
            resizable: true, resizeObjectName: 'SHAPE',
            selectionAdorned: true, selectionObjectName: 'SHAPE',
            reshapable: true, locationObjectName: 'SHAPE',
            locationSpot: go.Spot.TopLeft,
            selectionAdornmentTemplate: $(go.Adornment, 'Spot', $(go.Panel, go.Panel.Auto, $(go.Shape, { fill: null, stroke: 'dodgerblue', strokeWidth: 1 }, new go.Binding('stroke', 'locked', function (locked) { return locked ? '#f65177' : 'dodgerblue'; })), $(go.Placeholder, new go.Binding('padding', '', function (data) {
                if (data.pipeDiameter) {
                    return -data.pipeDiameter / 2;
                }
                else {
                    return -7;
                }
            }))))
        }, new go.Binding('location', 'loc', go.Point.parse).makeTwoWay(go.Point.stringify), new go.Binding('movable', 'locked', function (locked) { return !locked; }), new go.Binding('resizable', 'locked', function (locked) { return !locked; }), new go.Binding('deletable', 'locked', function (locked) { return !locked; }), new go.Binding('zOrder'), $(go.Shape, { name: 'SHAPE', stroke: '#60768c', strokeWidth: 14, geometryString: 'M 0 0 100 0', isPanelMain: true, strokeJoin: 'round', strokeMiterLimit: 20 }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('geometryString', 'geo').makeTwoWay(), new go.Binding('strokeDashArray', '', function (data) {
            return _this.getStrokeDasharray(data.lineType);
        }), new go.Binding('strokeWidth', 'pipeDiameter'), new go.Binding('stroke', '', function (data) {
            if (!data.hasOwnProperty('isPipeWall')) {
                return '#60768c';
            }
            if (data.isPipeWall === false) {
                return 'rgba(255,255,255,0)';
            }
            return data.pipeWallColor || '#60768c';
        })), $(go.Shape, { name: 'SHAPE', stroke: '#ffffff', strokeWidth: 12, geometryString: 'M 0 0 100 0', isPanelMain: true, strokeJoin: 'round', strokeMiterLimit: 20 }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('geometryString', 'geo').makeTwoWay(), new go.Binding('strokeWidth', '', function (data) {
            return data.pipeDiameter - 2 * data.pipeWallSize <= 0 ? 1 : data.pipeDiameter - 2 * data.pipeWallSize;
        }), new go.Binding('stroke', 'backGroundColor')), $(go.Shape, {
            name: 'SHAPE', stroke: '#0081ff', strokeWidth: 6, geometryString: 'M 0 0 100 0', isPanelMain: true,
            strokeDashArray: [12, 6], strokeJoin: 'round', strokeMiterLimit: 20
        }, new go.Binding('desiredSize', 'size', go.Size.parse).makeTwoWay(go.Size.stringify), new go.Binding('geometryString', 'geo').makeTwoWay(), new go.Binding('visible', 'isFlowBlock'), new go.Binding('strokeWidth', 'blockWidth'), new go.Binding('strokeDashArray', '', function (data) {
            var strokeDashArray = [];
            if (+data.blockLength > 0) {
                strokeDashArray.push(data.blockLength);
            }
            else {
                strokeDashArray.push(12);
            }
            if (+data.blockMargin >= 0) {
                strokeDashArray.push(data.blockMargin);
            }
            else {
                strokeDashArray.push(6);
            }
            return strokeDashArray;
        }), new go.Binding('stroke', 'blockColor')));
    };
    PipeElement.prototype.getCategoryKey = function () {
        return DiagramConsts.elements.pipeKey;
    };
    return PipeElement;
}(LineElement));
export { PipeElement };
